import FireReportSecurity from "../../security/FireReport";
import NotificationSecurity from "../../security/Notifications";
import WhiteListGuestsSecurity from "../../security/WhiteList/WhiteListGuestsSecurity";

const useNavLinksArray = () => {
  // const numberUnreadMessages = useAppSelector(selectNumberUnreadMessages);
  // const settings = useAppSelector(selectSettings);

  const navLinksArraySecurity: navLinksArrayTimeWorkerInterface = {
    profileId: 10,
    routesArrayWithComponents: [],
    hidenInNavBar: [
      {
        ifHidden: false,
        path: "/security/home",
        component: (props) => <NotificationSecurity {...props} />,
      },
      {
        ifHidden: false,
        path: "/security/fire-report",
        component: () => <FireReportSecurity />,
      },
      {
        ifHidden: false,
        path: "/security/white-list",
        component: () => <WhiteListGuestsSecurity />,
      },
    ],
  };

  return navLinksArraySecurity;
};
export default useNavLinksArray;
